export abstract class Entity {
  abstract toJson(): Map<string, any>;
}
